import React from 'react';
import { MapPin } from 'lucide-react';
import { ThemedText, MiniMap } from '../../../components';
import { parseCoordinates } from '../parsers';

export default function MapValue({ value, field, emptyValue = '—', theme }) {
  const coords = parseCoordinates(value);
  if (!coords) {
    return <ThemedText style={{ color: theme?.colors?.muted }}>No location data</ThemedText>;
  }

  return (
    <div>
      <ThemedText style={{ marginBottom: theme?.spacing?.sm || 8 }}>
        <MapPin size={14} style={{ display: 'inline', verticalAlign: 'middle' }} />{' '}
        {coords.latitude.toFixed(6)}, {coords.longitude.toFixed(6)}
        {coords.accuracy && ` (±${Math.round(coords.accuracy)}m)`}
      </ThemedText>
      <MiniMap
        latitude={coords.latitude}
        longitude={coords.longitude}
        height="200px"
        zoom={15}
        label={field?.props?.label}
        accuracy={coords.accuracy}
        showButtons={true}
      />
    </div>
  );
}
